module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_MT-c671f111424ab92c688b234d31ffa53a.svg";